import Keycloak from 'keycloak-js';
import { identityServerReachable, issuerFromConfig } from 'shared/signin/signInRedirect';

/**
 * Keycloak singleton for the 24K.Infinity provider portal.
 *
 * Configuration is drawn from CRA env vars so each environment
 * (local, staging, production) can supply its own values without
 * touching source code:
 *
 *   REACT_APP_KEYCLOAK_URL        https://auth.24k.infinity.surbana.tech
 *   REACT_APP_KEYCLOAK_REALM      infinity
 *   REACT_APP_KEYCLOAK_CLIENT_ID  infinity-provider
 */
const providerHost = typeof window !== 'undefined' ? window.location.hostname : '';
const isStagingInfinityHost = providerHost === '24k.infinity.surbana.tech';

const config = {
  url:      process.env.REACT_APP_KEYCLOAK_URL      || 'https://keycloak-staging.24k-ops.surbana.tech',
  realm:    process.env.REACT_APP_KEYCLOAK_REALM    || (isStagingInfinityHost ? '24k-infinity' : '24k-ops'),
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || (isStagingInfinityHost ? 'app-provider-staging' : 'provider'),
};
const keycloak = new Keycloak(config);

/** False when the identity server does not answer, so the app shows its error state instead of redirecting there. */
export const identityReachable = () => identityServerReachable(issuerFromConfig(config));

export default keycloak;
